<template>
  <div
    v-if="!isOwnerLot"
    class="lg:hidden fixed z-20 bottom-0 left-0 right-0 bg-white p-4 shadow-[0_-4px_8px_rgba(0,0,0,0.1)]"
  >
    <div class="flex gap-2 w-full">
      <PolkaBtn
        color="primary"
        size="large"
        class="flex-1 min-w-0 rounded-2xl"
        @click="handleAskQuestion"
      >
        <span class="text-base font-semibold">Написать</span>
      </PolkaBtn>

      <LotsShowPhoneButton
        v-if="showPhoneButton"
        :phone="ownerPhone"
        color="success"
        button-class="flex-1 min-w-0 rounded-2xl"
        @click="handleCall"
      />
    </div>
  </div>
</template>

<script setup>
import { buildAnalyticsStore } from '~/analytics/composables-types'
import LotsShowPhoneButton from '~/components/lots/show/phone_button.vue'
import PolkaBtn from '~/components/shared/polka_btn.vue'
import {
  getClickOwnerCallAmplitudePayload,
  getOwnerCallType,
  getOwnerPhoneType,
} from '~/composables/useClickOwnerCallAnalytics'
import { getClickOwnerChatAmplitudePayload } from '~/composables/useClickOwnerChatAnalytics'
import { useLot } from '~/composables/useLot'

const props = defineProps({
  lotId: {
    type: [String, Number],
    required: true,
  },
  phone: {
    type: Boolean,
    default: true,
  },
})

const { $tracking, $modal } = useNuxtApp()
const { lot } = useLot(props.lotId)
const { currentUserId } = useAuth()

const isOwnerLot = computed(() => {
  return Number(currentUserId.value) === Number(lot.value?.user?.id)
})

const ownerPhone = computed(() => {
  return lot.value?.user?.phoneProxy || lot.value?.user?.phonePublic || null
})

const showPhoneButton = computed(() => {
  if (!ownerPhone.value || !props.phone) {
    return false
  }
  return true
})

const handleCall = ({ canDial }) => {
  if (!lot.value || !ownerPhone.value) return

  try {
    $tracking.logEventYA('click_owner_call')
  } catch {
    // ym может быть недоступен в dev
  }

  try {
    $tracking.logEventAmplitude(
      'click owner call',
      getClickOwnerCallAmplitudePayload({
        store: buildAnalyticsStore(),
        lot: lot.value,
        user: lot.value.user,
        callType: getOwnerCallType(canDial),
        phoneType: getOwnerPhoneType({
          userPhone: lot.value.user?.phone,
          ownerPhone: ownerPhone.value,
          phonePublic: lot.value.user?.phonePublic,
          phoneProxy: lot.value.user?.phoneProxy,
        }),
      }),
    )
  } catch {
    // не блокируем звонок из-за ошибки аналитики
  }
}

const handleAskQuestion = () => {
  try {
    $tracking.logEventYA('click_chat_product')
  } catch {
    // ym может быть недоступен в dev
  }

  try {
    $tracking.logEventAmplitude(
      'click owner chat',
      getClickOwnerChatAmplitudePayload({
        store: buildAnalyticsStore(),
        lot: lot.value,
        user: lot.value.user,
      }),
    )
  } catch {
    // не блокируем чат из-за ошибки аналитики
  }

  $modal.show('flow/go_chat_from_lot', { lotId: props.lotId })
}
</script>
